import { render } from "./AtividadeList.vue?vue&type=template&id=493ea4e9"
import script from "./AtividadeList.vue?vue&type=script&lang=js"
export * from "./AtividadeList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__